import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';
import Input from './input';
import Modal from 'components/modal';
import { Errors } from 'components/ui/errors';

export default function CommentModal({ comment, show, updateComment, onHide }) {
  const [body, setBody] = useState(comment?.body || '');
  const [saving, setSaving] = useState();
  const [errors, setErrors] = useState();

  async function handleSave() {
    setSaving(true);
    const updatedComment = { ...comment, body };
    try {
      await updateComment(updatedComment);
      onHide();
    } catch (errors) {
      setErrors(errors);
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal className="deal-comment-modal" show={show} onHide={onHide}>
      <Modal.Header closeButton>
        Edit Message
      </Modal.Header>

      <Modal.Body>
        <Errors errors={errors} />
        <Input comment={comment} onChange={setBody} />
      </Modal.Body>

      <Modal.Footer>
        <Button label="Cancel" name="cancel" variant="ghost" onClick={onHide} />
        <Button disabled={saving} label="Save" name="save" onClick={handleSave} />
      </Modal.Footer>
    </Modal>
  );
}

CommentModal.propTypes = {
  comment: PropTypes.shape({
    body: PropTypes.string,
  }),
  show: PropTypes.bool,
  updateComment: PropTypes.func,
  onHide: PropTypes.func.isRequired
};
